import page404 from "../../components/pages/page404";
export default [
    {
        path            : '/404',
        name            : 'page404',
        component       : page404
    },
    {
        path            : '*',
        redirect        : {name: 'page404'}
    },
]